// extracted by mini-css-extract-plugin
export default {"wrap":"InitInfo_wrap__vGhN7","label":"InitInfo_label__btWtr","value":"InitInfo_value__0Hj0l"};